import { render } from 'preact';

import App from './App';
const TEST_BREAKS = [
  'Pokai-Bay',
  'Hampton-Beach',
  'Asilomar',
  'Garie-Point',
  'Pines-Wainui-Beach',
  'Playade-Carnota',
  'Rest-Bay',
];

export default function init(target, swellState, wind) {
  if (TEST_BREAKS.includes(FCGON.filename_part)) {
    render(<App swellData={swellState} windData={wind} />, target);
  }
  return () => render(null, target);
}
